// Kleine set lijniconen (24-raster, stroke), zodat er geen iconenbibliotheek nodig is.

const PATHS: Record<string, string> = {
  mail: 'M4 6h16v12H4z M4 7l8 6 8-6',
  chat: 'M4 5h16v11H9l-5 4z',
  calendar: 'M4 6h16v14H4z M4 10h16 M8 3v4 M16 3v4',
  sliders: 'M4 7h9 M17 7h3 M4 17h3 M11 17h9 M13 5v4 M7 15v4',
  code: 'M8 7l-5 5 5 5 M16 7l5 5-5 5',
  mic: 'M12 3a3 3 0 0 1 3 3v6a3 3 0 0 1-6 0V6a3 3 0 0 1 3-3z M6 11a6 6 0 0 0 12 0 M12 17v4 M9 21h6',
  flag: 'M6 21V4h10l-1.5 3L16 10H6',
  clip: 'M20 12l-8.5 8.5a5 5 0 0 1-7-7L13 5a3.5 3.5 0 0 1 5 5l-8.5 8.5a2 2 0 0 1-3-3L15 7',
  search: 'M10 4a6 6 0 1 1 0 12 6 6 0 0 1 0-12z M15 15l5 5',
  folder: 'M3 6h6l2 2h10v11H3z',
  chevron: 'M9 6l6 6-6 6',
  down: 'M6 9l6 6 6-6',
  x: 'M6 6l12 12 M18 6L6 18',
  plus: 'M12 5v14 M5 12h14',
  check: 'M5 12l5 5L20 7',
  user: 'M12 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8z M4 21a8 8 0 0 1 16 0',
  panes1: 'M4 5h16v14H4z',
  panes2: 'M4 5h7v14H4z M13 5h7v14h-7z',
  rail: 'M4 5h16v14H4z M15 5v14',
  send: 'M4 12l16-8-4 16-4-6z',
  reply: 'M9 7L4 12l5 5 M4 12h10a6 6 0 0 1 6 6',
  replyAll: 'M7 7L2 12l5 5 M12 7l-5 5 5 5 M7 12h7a6 6 0 0 1 6 6',
  forward: 'M15 7l5 5-5 5 M20 12H10a6 6 0 0 0-6 6',
  archive: 'M3 5h18v4H3z M5 9v10h14V9 M10 13h4',
  trash: 'M4 7h16 M9 7V4h6v3 M6 7l1 13h10l1-13',
  move: 'M3 6h6l2 2h10v11H3z M12 11v6 M9 14l3 3 3-3',
  read: 'M4 6h16v12H4z M4 7l8 6 8-6 M4 18l6-5 M20 18l-6-5',
  unread: 'M4 6h16v12H4z M4 7l8 6 8-6 M18 4l0 0',
  star: 'M12 3l2.8 5.7 6.2.9-4.5 4.4 1 6.2L12 17.3 6.5 20.2l1-6.2L3 9.6l6.2-.9z',
  spinner: 'M12 3a9 9 0 0 1 9 9',
  question: 'M9 9a3 3 0 1 1 4 2.8c-.7.3-1 .9-1 1.7V15 M12 19h0',
  bolt: 'M13 2L4 14h7l-1 8 9-12h-7z',
  wave: 'M3 12h2l2-6 3 12 3-9 2 6 2-3h4',
  stop: 'M6 6h12v12H6z',
  play: 'M7 5l12 7-12 7z',
  settings: 'M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8z M4 12h2 M18 12h2 M12 4v2 M12 18v2 M6.3 6.3l1.4 1.4 M16.3 16.3l1.4 1.4 M6.3 17.7l1.4-1.4 M16.3 7.7l1.4-1.4',
  book: 'M4 4h7a3 3 0 0 1 3 3v13a2 2 0 0 0-2-2H4z M20 4h-7a3 3 0 0 0-3 3v13a2 2 0 0 1 2-2h8z',
  chart: 'M4 20h16 M7 17V9 M12 17V5 M17 17v-6',
  sun: 'M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8z M12 2v2 M12 20v2 M2 12h2 M20 12h2 M5 5l1.5 1.5 M17.5 17.5L19 19 M5 19l1.5-1.5 M17.5 6.5L19 5',
  logout: 'M10 4H4v16h6 M14 8l5 4-5 4 M19 12H9',
  undo: 'M9 8L4 12l5 4 M4 12h10a6 6 0 0 1 0 12',
  pen: 'M4 20l4-1L19 8l-3-3L5 16z M14 7l3 3',
  eye: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z',
  download: 'M12 4v12 M7 11l5 5 5-5 M4 20h16',
  external: 'M14 4h6v6 M20 4l-9 9 M18 14v6H4V6h6',
  refresh: 'M20 12a8 8 0 1 1-2.3-5.7 M20 4v5h-5',
  table: 'M4 5h16v14H4z M4 10h16 M4 15h16 M10 5v14',
  dot: 'M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0-6 0',
  sort: 'M6 4v16 M3 17l3 3 3-3 M12 6h9 M12 12h6 M12 18h3',
  menu: 'M4 7h16 M4 12h16 M4 17h16',
  more: 'M5 12h0 M12 12h0 M19 12h0',
  steps: 'M5 7h0 M10 7h9 M5 12h0 M10 12h9 M5 17h0 M10 17h9',
  image: 'M4 5h16v14H4z M4 16l5-5 4 4 3-3 4 4 M15 8h0',
  info: 'M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18z M12 11v5 M12 8h0',
  warning: 'M12 3l10 18H2z M12 10v4 M12 17h0',
  clock: 'M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18z M12 7v5l3 2',
  file: 'M6 3h8l4 4v14H6z M14 3v4h4',
  volume: 'M4 10v4h3l5 4V6L7 10z M16 9a4 4 0 0 1 0 6 M18.5 6.5a8 8 0 0 1 0 11',
  /** Vergroten: twee pijlen naar buiten (de lezer of het mailpaneel over de volle breedte). */
  expand: 'M15 4h5v5 M20 4l-6 6 M9 20H4v-5 M4 20l6-6',
  /** Verkleinen: twee pijlen naar binnen (de lijst of het gesprek weer ernaast). */
  shrink: 'M14 5v5h5 M20 4l-6 6 M10 19v-5H5 M4 20l6-6',
  /** Weergave: een venster met de lijst links en het leesvenster rechts. */
  layout: 'M4 5h16v14H4z M10 5v14',
  /** WhatsApp: een ronde spraakwolk met een staartje linksonder (geen merklogo). */
  whatsapp: 'M8.25 18.86A8.5 8.5 0 1 0 5.14 15.75L3 21z',
};

export type IconName = keyof typeof PATHS;

export function Icon(props: { name: IconName; size?: number | undefined; className?: string | undefined; stroke?: number | undefined; title?: string | undefined }) {
  const size = props.size ?? 18;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={props.stroke ?? 1.8} strokeLinecap="round" strokeLinejoin="round" className={props.className ?? ''} aria-hidden={props.title ? undefined : true} role={props.title ? 'img' : undefined}>
      {props.title ? <title>{props.title}</title> : null}
      <path d={PATHS[props.name] ?? ''} />
    </svg>
  );
}

/** Het merkteken van Jerome (golfje in een donker vierkant). */
export function JeromeMark(props: { size?: number | undefined; className?: string | undefined; tone?: 'brand' | 'inverse' | undefined }) {
  const size = props.size ?? 26;
  // Op een donkere balk (telefoon) is de wolk wit met een blauwe J; de vonk blijft oranje.
  const inverse = props.tone === 'inverse';
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={props.className ?? ''} aria-hidden="true">
      {/* Praatwolk in Hero-blauw met een strakke J en een oranje vonk (zelfde teken als de favicon). */}
      <path d="M14 4h36a10 10 0 0 1 10 10v30a10 10 0 0 1-10 10H27l-9 8v-8h-4A10 10 0 0 1 4 44V14A10 10 0 0 1 14 4z" fill={inverse ? '#ffffff' : '#073889'} />
      <path d="M24 18h20M37 18v20a8 8 0 0 1-15 4" fill="none" stroke={inverse ? '#073889' : '#ffffff'} strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="49" cy="40" r="5" fill="#f46015" />
    </svg>
  );
}
